import { render, staticRenderFns } from "./Type9.vue?vue&type=template&id=e6ddbc94&scoped=true"
import script from "./Type9.vue?vue&type=script&lang=js"
export * from "./Type9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6ddbc94",
  null
  
)

export default component.exports